import React, { useState } from 'react';
import { buttonStyle, inputStyle, sectionHeaderStyle } from './styles';

interface TeleportControlsProps {
  onAction: (action: string, data?: any) => void;
}

export const TeleportControls: React.FC<TeleportControlsProps> = ({ onAction }) => {
  const [teleportX, setTeleportX] = useState(100);
  const [teleportY, setTeleportY] = useState(100);

  return (
    <>
      <div style={sectionHeaderStyle}>Teleport</div>
      <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
        <input
          type="number"
          style={{ ...inputStyle, marginBottom: 0 }}
          value={teleportX}
          onChange={(e) => setTeleportX(Number(e.target.value))}
          placeholder="X"
        />
        <input
          type="number"
          style={{ ...inputStyle, marginBottom: 0 }}
          value={teleportY}
          onChange={(e) => setTeleportY(Number(e.target.value))}
          placeholder="Y"
        />
      </div>
      <button style={buttonStyle} onClick={() => onAction('teleport', { x: teleportX, y: teleportY })}>🚀 Teleport to Coords</button>
      <button style={buttonStyle} onClick={() => onAction('teleport', { x: 100, y: 500 })}>🏠 Spawn Point</button>
      <button style={buttonStyle} onClick={() => onAction('teleport', { x: 1500, y: 500 })}>🌲 Forest Edge</button>
      <button style={buttonStyle} onClick={() => onAction('teleport', { x: 3000, y: 400 })}>🏔️ Mountain Top</button>
    </>
  );
};
